import './NeedHelp.scss';

import { BRIDGE_BIO_CAMPAIGN_CODE } from '@constants/bridgeBio';
import { MYOME_SUPPORT_EMAIL, MYOME_SUPPORT_PHONE, MYOME_SUPPORT_PHONE_TEL, RESOURCES_URL } from '@constants/constants';
import useApp from '@hooks/useApp';
import handshakeIcon from '@statics/images/handshake-light.svg';

export interface NeedHelpProps {
  /** `band` is the full-width Home layout; `card` is the light-blue sidebar tile on My Results. */
  variant?: 'band' | 'card';
}

export const NeedHelp = (props: NeedHelpProps) => {
  const { variant = 'card' } = props;
  const { campaignCode, isLoadingUserInfo } = useApp();
  const showResources = campaignCode !== BRIDGE_BIO_CAMPAIGN_CODE && !isLoadingUserInfo;

  const heading = "We're here at every step";
  const resourcesLink = showResources && (
    <>
      {' '}
      Find quick answers in our{' '}
      <a target='_blank' href={RESOURCES_URL} className='fw-medium' rel='noreferrer'>
        Patient Resources
      </a>
      .
    </>
  );

  if (variant === 'band') {
    return (
      <section className='support-tile support-tile--band' data-testid='needHelp'>
        <div className='support-tile__intro'>
          <img className='support-tile__icon' src={handshakeIcon} alt='' width={56} height={56} />
          <div className='support-tile__copy'>
            <h2 className='support-tile__heading'>{heading}</h2>
            <p className='support-tile__body'>
              MyOme support can help with kits, shipping, results, and anything else you need.
              {resourcesLink}
            </p>
          </div>
        </div>

        <div className='support-tile__contacts'>
          <div className='support-tile__contact'>
            <span className='support-tile__contact-label'>Email</span>
            <a href={`mailto:${MYOME_SUPPORT_EMAIL}`} className='support-tile__contact-value'>
              {MYOME_SUPPORT_EMAIL}
            </a>
          </div>
          <div className='support-tile__contact'>
            <span className='support-tile__contact-label'>Phone</span>
            <a href={MYOME_SUPPORT_PHONE_TEL} className='support-tile__contact-value'>
              {MYOME_SUPPORT_PHONE}
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className='bg-light-blue p-3 rounded-4 need-help' data-testid='needHelp'>
      <img className='need-help__icon' src={handshakeIcon} alt='' width={56} height={56} />
      <p className='fs-sm fw-semibold font-family-custom mb-2'>{heading}</p>
      <p className='fs-xs'>
        MyOme support can help with kits, shipping, results, and anything else you need.
        {resourcesLink}
      </p>
      <p className='fs-xs mb-1'>
        Email{' '}
        <a href={`mailto:${MYOME_SUPPORT_EMAIL}`} className='fw-medium'>
          {MYOME_SUPPORT_EMAIL}
        </a>
      </p>
      <p className='fs-xs mb-0'>
        Phone{' '}
        <a href={MYOME_SUPPORT_PHONE_TEL} className='fw-medium'>
          {MYOME_SUPPORT_PHONE}
        </a>
      </p>
    </section>
  );
};
